var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcMachineManagement(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 23,
    viewBox: "0 0 28 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20 0H2C0.89543 0 0 0.89543 0 2V15C0 16.1046 0.89543 17 2 17H20C21.1046 17 22 16.1046 22 15V2C22 0.89543 21.1046 0 20 0Z",
    fill: "#BAD5FF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M23 3H5C3.89543 3 3 3.89543 3 5V18C3 19.1046 3.89543 20 5 20H23C24.1046 20 25 19.1046 25 18V5C25 3.89543 24.1046 3 23 3Z",
    fill: "#79A2FF"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M26 6H8C6.89543 6 6 6.89543 6 8V21C6 22.1046 6.89543 23 8 23H26C27.1046 23 28 22.1046 28 21V8C28 6.89543 27.1046 6 26 6Z",
    fill: "#263FC7"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcMachineManagement);
export default __webpack_public_path__ + "static/media/ic_machine_management.aa13e9d35be0bba39a48ae5d9c05145c.svg";
export { ForwardRef as ReactComponent };